export default class Sogeti {
    constructor($location) {
        this._location = $location;

        this.countries = [
            'Sweden', 'Norway', 'Finland', 'USA', 'United kingdom', 'Spain', 'Belgium', 'Luxembourg',
            'Netherlands', 'India', 'Germany', 'Ireland', 'France', 'Denmark', 'Switzerland'];

        this.divisions = [
            'Norr', 'Svea', 'Syd', 'Norway', 'Belgium', 'Finland', 'France'
        ];

        this.offices = [
            'Sweden', 'Digitalt', 'Borlänge', 'Gävle', 'Karlstad', 'Luleå', 'Sandviken', 'Sundsvall', 'Umeå', 'Västerås',
            'Örebro', 'Örsköldsvik', 'Linköping', 'Norrköping', 'Nyköping', 'Oxelösund', 'Stockholm',
            'Uppsala', 'Borås', 'Göteborg', 'Helsingborg', 'Jönköping', 'Malmö', 'Skövde', 'Oslo', 'Paris',
            'Brussels', 'Helsinki', 'Östersund', 'Eskilstuna'
        ];

        this.locationSettings = {
            'rule-dev': {
                1: {country: 'Sweden', office: 'Stockholm', division: 'Svea'}
            },
            'staging.rule.io': {
                2692: { country: 'Sweden', office: 'Stockholm', division: 'Svea'},
                2693: { country: 'Sweden', office: 'Stockholm', division: 'Svea'},
                2694: { country: 'Sweden', office: 'Umeå', division: 'Norr'},
                2695: { country: 'Sweden', office: 'Gävle', division: 'Norr'},
                2696: { country: 'Sweden', office: 'Karlstad', division: 'Norr'},
                2697: { country: 'Sweden', office: 'Uppsala', division: 'Svea'},
                2699: { country: 'Sweden', office: 'Stockholm', division: 'Svea'},
                2700: { country: 'Sweden', office: 'Västerås', division: 'Norr'},
                2701: { country: 'Sweden', office: 'Helsingborg', division: 'Syd'},
                2702: { country: 'Sweden', office: 'Linköping', division: 'Svea'},
                2703: { country: 'Sweden', office: 'Borlänge', division: 'Norr'},
                2704: { country: 'Sweden', office: 'Nyköping', division: 'Svea'},
                2705: { country: 'Sweden', office: 'Örnsköldsvik', division: 'Norr'},
                2706: { country: 'Sweden', office: 'Norrköping', division: 'Svea'},
                2707: { country: 'Sweden', office: 'Skövde', division: 'Syd'},
                2708: { country: 'Sweden', office: 'Jönköping', division: 'Syd'},
                2709: { country: 'Sweden', office: 'Borås', division: 'Syd'},
                2710: { country: 'Sweden', office: 'Göteborg', division: 'Syd'},
                2711: { country: 'Sweden', office: 'Malmö', division: 'Syd'},
                2712: { country: 'Sweden', office: 'Sundsvall', division: 'Norr'},
                2713: { country: 'Sweden', office: 'Örebro', division: 'Norr'},
                2714: { country: 'Sweden', office: 'Göteborg', division: 'Syd'},
                2715: { country: 'Sweden', office: 'Luleå', division: 'Norr'},
                2716: { country: 'Belgium', office: 'Brussels', division: 'Belgium'},
                2717: { country: 'Belgium', office: 'Brussels', division: 'Belgium'},
                2718: { country: 'Belgium', office: 'Brussels', division: 'Belgium'},
                2719: { country: 'Finland', office: 'Helsinki', division: 'Finland'},
                2720: { country: 'France', office: 'Paris', division: 'France'},
                2721: { country: 'Norway', office: 'Oslo', division: 'Norway'},
                3354: { country: 'Sweden', office: 'Sandviken', division: 'Norr'},
                6474: { country: 'Sweden', office: 'Östersund', division: 'Norr'},
                11290: { country: 'Sweden', office: 'Eskilstuna', division: 'Svea'}
            },
            'staging2.rule.io': {
                2692: { country: 'Sweden', office: 'Stockholm', division: 'Svea'},
                2693: { country: 'Sweden', office: 'Stockholm', division: 'Svea'},
                2694: { country: 'Sweden', office: 'Umeå', division: 'Norr'},
                2695: { country: 'Sweden', office: 'Gävle', division: 'Norr'},
                2696: { country: 'Sweden', office: 'Karlstad', division: 'Norr'},
                2697: { country: 'Sweden', office: 'Uppsala', division: 'Svea'},
                2699: { country: 'Sweden', office: 'Stockholm', division: 'Svea'},
                2700: { country: 'Sweden', office: 'Västerås', division: 'Norr'},
                2701: { country: 'Sweden', office: 'Helsingborg', division: 'Syd'},
                2702: { country: 'Sweden', office: 'Linköping', division: 'Svea'},
                2703: { country: 'Sweden', office: 'Borlänge', division: 'Norr'},
                2704: { country: 'Sweden', office: 'Nyköping', division: 'Svea'},
                2705: { country: 'Sweden', office: 'Örnsköldsvik', division: 'Norr'},
                2706: { country: 'Sweden', office: 'Norrköping', division: 'Svea'},
                2707: { country: 'Sweden', office: 'Skövde', division: 'Syd'},
                2708: { country: 'Sweden', office: 'Jönköping', division: 'Syd'},
                2709: { country: 'Sweden', office: 'Borås', division: 'Syd'},
                2710: { country: 'Sweden', office: 'Göteborg', division: 'Syd'},
                2711: { country: 'Sweden', office: 'Malmö', division: 'Syd'},
                2712: { country: 'Sweden', office: 'Sundsvall', division: 'Norr'},
                2713: { country: 'Sweden', office: 'Örebro', division: 'Norr'},
                2714: { country: 'Sweden', office: 'Göteborg', division: 'Syd'},
                2715: { country: 'Sweden', office: 'Luleå', division: 'Norr'},
                2716: { country: 'Belgium', office: 'Brussels', division: 'Belgium'},
                2717: { country: 'Belgium', office: 'Brussels', division: 'Belgium'},
                2718: { country: 'Belgium', office: 'Brussels', division: 'Belgium'},
                2719: { country: 'Finland', office: 'Helsinki', division: 'Finland'},
                2720: { country: 'France', office: 'Paris', division: 'France'},
                2721: { country: 'Norway', office: 'Oslo', division: 'Norway'},
                3354: { country: 'Sweden', office: 'Sandviken', division: 'Norr'},
                6474: { country: 'Sweden', office: 'Östersund', division: 'Norr'},
                11290: { country: 'Sweden', office: 'Eskilstuna', division: 'Svea'}
            },
            'app.rule.io': {
                2692: { country: 'Sweden', office: 'Stockholm', division: 'Svea'},
                2693: { country: 'Sweden', office: 'Stockholm', division: 'Svea'},
                2694: { country: 'Sweden', office: 'Umeå', division: 'Norr'},
                2695: { country: 'Sweden', office: 'Gävle', division: 'Norr'},
                2696: { country: 'Sweden', office: 'Karlstad', division: 'Norr'},
                2697: { country: 'Sweden', office: 'Uppsala', division: 'Svea'},
                2699: { country: 'Sweden', office: 'Stockholm', division: 'Svea'},
                2700: { country: 'Sweden', office: 'Västerås', division: 'Norr'},
                2701: { country: 'Sweden', office: 'Helsingborg', division: 'Syd'},
                2702: { country: 'Sweden', office: 'Linköping', division: 'Svea'},
                2703: { country: 'Sweden', office: 'Borlänge', division: 'Norr'},
                2704: { country: 'Sweden', office: 'Nyköping', division: 'Svea'},
                2705: { country: 'Sweden', office: 'Örnsköldsvik', division: 'Norr'},
                2706: { country: 'Sweden', office: 'Norrköping', division: 'Svea'},
                2707: { country: 'Sweden', office: 'Skövde', division: 'Syd'},
                2708: { country: 'Sweden', office: 'Jönköping', division: 'Syd'},
                2709: { country: 'Sweden', office: 'Borås', division: 'Syd'},
                2710: { country: 'Sweden', office: 'Göteborg', division: 'Syd'},
                2711: { country: 'Sweden', office: 'Malmö', division: 'Syd'},
                2712: { country: 'Sweden', office: 'Sundsvall', division: 'Norr'},
                2713: { country: 'Sweden', office: 'Örebro', division: 'Norr'},
                2714: { country: 'Sweden', office: 'Göteborg', division: 'Syd'},
                2715: { country: 'Sweden', office: 'Luleå', division: 'Norr'},
                2716: { country: 'Belgium', office: 'Brussels', division: 'Belgium'},
                2717: { country: 'Belgium', office: 'Brussels', division: 'Belgium'},
                2718: { country: 'Belgium', office: 'Brussels', division: 'Belgium'},
                2719: { country: 'Finland', office: 'Helsinki', division: 'Finland'},
                2720: { country: 'France', office: 'Paris', division: 'France'},
                2721: { country: 'Norway', office: 'Oslo', division: 'Norway'},
                3354: { country: 'Sweden', office: 'Sandviken', division: 'Norr'},
                6474: { country: 'Sweden', office: 'Östersund', division: 'Norr'},
                11290: { country: 'Sweden', office: 'Eskilstuna', division: 'Svea'}
            }
        };

        this.sogetiAccounts = {
            'local': [1, 2, 2692],
            'staging': [2692,2693,2694,2695,2696,2697,2699,2700,2701,2702,2703,2704,2705,2706,2707,2708,2709,2710,2711,2712,2713,2714,2715,2716,2717,2718,2719,2720,2721,3354,6474,11290],
            'production': [2692,2693,2694,2695,2696,2697,2699,2700,2701,2702,2703,2704,2705,2706,2707,2708,2709,2710,2711,2712,2713,2714,2715,2716,2717,2718,2719,2720,2721,3232,3354,6474,11290]
        };

        this.roles = [
            {
                'id': 11,
                'name': 'Sogeti'
            },
            {
                'id': 12,
                'name': 'Sogeti Admin'
            }
        ];

        this.requiredBlocks = [
            'Heading',
            'Date and location',
            'Preamble',
            'Content'
        ];
    }

    isSogetiAccount(accountId) {
        var accounts = [];

        switch (this._location.host()) {
            case 'rule-dev':
                accounts = this.sogetiAccounts['local'];
                break;
            case 'staging.rule.io':
            case 'staging2.rule.io':
                accounts = this.sogetiAccounts['staging'];
                break;
            case 'app.rule.io':
                accounts = this.sogetiAccounts['production'];
                break;
        }

        return accounts.indexOf(accountId) !== -1;
    };

    getLocationSettings(accountId) {
        return this.locationSettings[this._location.host()][accountId];
    };

    getCountries() {
        return this.countries;
    };
    
    getDivisions() {
        return this.divisions;
    };

    getOffices(accountId) {
        if (accountId === 2721) {
            return this.offices.concat(['Bergen', 'Stavanger', 'Trondheim'])
        }

        return this.offices;
    };

    getRoles() {
        return this.roles;
    }

    templateHasAllRequiredImages(template) {
        const isPageThumbnail = (image) => image.type.id === 2;
        const isBackground = (image) => image.type.id === 3;
        const templateImagesData = template.templateImages.data;

        return templateImagesData.some(isPageThumbnail) && templateImagesData.some(isBackground);
    }

    templateHasAllRequiredBlocks(templateSource) {
        return this.requiredBlocks.every((blockName) => templateSource.includes(`data-rule-block-name="${blockName}"`));
    }
};
